// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".niQJR{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:32px}.tabs{margin-bottom:3.2rem}.n8V-e{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.n8V-e>button{background:transparent;display:inline-block;margin-left:-1.6rem;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.n8V-e>div,form{display:-ms-flexbox;display:flex}form{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-positive:100;flex-grow:100}form>h5:first-of-type{margin-top:0}form div.row{-ms-flex-align:start;align-items:flex-start}form div.row div.form-group{margin:0}", ""]);
// Exports
exports.locals = {
	"configureCountry": "niQJR",
	"configureCountry__header": "n8V-e"
};
module.exports = exports;
